import Immutable from 'immutable';
import type { Map } from 'immutable';
import type { AnyAction } from 'redux';
import { GET_DWH_DATA } from './actions';

interface LineDataStateShape {
  loading: boolean;
  errorMessage?: string;
  [key: string]: boolean | string | Record<string, unknown> | undefined;
}

type LineDataState = Map<string, unknown>;

export default function lineDataReducer(
  state: LineDataState = Immutable.fromJS({
    loading: false,
  }) as LineDataState,
  action: AnyAction,
): LineDataState {
  const shopId = String(action.shopSqlId);
  const dataType: string = action.dataType;

  switch (action.type) {
    case `${GET_DWH_DATA}_LOADING`: {
      return state.merge({ loading: true });
    }
    case `${GET_DWH_DATA}_ERROR`: {
      return state.merge({
        errorMessage: 'Error fetching data for graph chart',
        loading: false,
      });
    }
    case GET_DWH_DATA: {
      const newState = Object.assign({}, state.toJS() as LineDataStateShape, {
        loading: false,
      });

      if (!newState[shopId]) {
        newState[shopId] = {};
      }

      const shopData = newState[shopId] as Record<string, unknown>;
      shopData[dataType] = action.data.data;
      return state.merge(Immutable.fromJS(newState));
    }
    default: {
      return state;
    }
  }
}
